import { tv } from '@costar-ui/cosmos';
import fieldOptions from '../../../common/field-options/field-options.esm.js';

var fieldGroupTV = fieldOptions;
var base = tv(fieldGroupTV);
var fieldGroupStyles = {
  base: base
};

export { fieldGroupStyles, fieldGroupTV };
//# sourceMappingURL=field-group.styles.esm.js.map
